/**
 * Theme tokens. Single source of truth for design values referenced from TS
 * (e.g., Cytoscape stylesheets that need raw color hex strings).
 *
 * Tailwind classes (`bg-paper-50`, etc.) read from tailwind.config.ts which
 * mirrors these values.
 */
export const colors = {
  paper: { 50: '#FBF8F1', 100: '#F4EFE0', 200: '#E8DFC4' },
  sage: {
    100: '#E5EBD9', 300: '#A6B996', 500: '#6E8364', 700: '#4A5E42', 900: '#2C3A26',
  },
  bark: { 300: '#C2A78A', 500: '#8B6F4F', 700: '#5C4830' },
  bloom: { 300: '#E6B8C5', 500: '#C4738A' },
  ink: { 600: '#3D2E1F', 900: '#1F1612' },
} as const;

export const typography = {
  display: '"Cormorant Garamond", Georgia, serif',
  body: '"Source Sans 3", system-ui, sans-serif',
  mono: '"JetBrains Mono", monospace',
} as const;

export const radii = { sm: '4px', md: '8px', lg: '12px', xl: '20px' } as const;
